export enum CalledFrom {
  PORTFOLIO = 'portfolio',
  PROJECT = 'project',
  ANALYTICS = 'analytics',
  CUSTOM_TABS_PORTFOLIO = 'customTabsPortfolio',
  CUSTOM_TABS_PROJECT = 'customTabsProject',
  EARLY_WARNINGS = 'earlyWarningsSection',
}
